// Copyright (c) 2017 Deere & Company

import SpecialAllowanceClaimStatusReport from '../../../reports/special-allowance-claim-status/state-connector';

export default {
    component: SpecialAllowanceClaimStatusReport,
    name: 'SPECIAL_ALLOWANCE_CLAIM_STATUS',
    path: 'special-allowance-claim-status'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/reports/special-allowance-claim-status.js